<template>
    <div class="newsInfo">
      <img class="banner animated fadeIn" src="../assets/newsB.png" alt="" id="d1">
      <div class="mainCon">
        <h2>{{info.TITLE}}</h2>
        <h3>{{info.NOTETIME}}</h3>
        <hr>
        <div class="htmlCon" v-html="info.CONTENT">
        </div>
      </div>
      <foot-Component @gotoTop="gotoTop"></foot-Component>
    </div>
</template>

<script>
  import Scrollbar from 'smooth-scrollbar';
  import footComponent from "./foot"
  import {getNewsInfo} from '../util/lang'
    export default {
        name: "newsInfo",
      data(){
          return{
            info:{}
          }
      },
      mounted(){
        Scrollbar.initAll(document.getElementById("scroller-wrapper"));
        this.getNews(this.$route.query.id)
      },
      components:{footComponent},
      methods:{
        getNews(id){
          this.$nextTick(()=>{
            const url = `${getNewsInfo( this.$i18n.locale,id)}`
            this.$axios.get(url).then(res => {
              this.info=res.data
              console.log(res.data)
            })
          })
        },
        gotoTop(){
          Scrollbar.get(document.getElementById('scroller-wrapper')).scrollIntoView(document.querySelector("#d1"))
        },
      }
    }
</script>

<style scoped>
.newsInfo{
  width:100%;
}
  .mainCon{
    width:1280px;
    margin: 0 auto;
    text-align: center;
  padding: 30px 0;
  }
  .htmlCon{
    width:100%;
    line-height: 30px;
  padding: 30px 0;
    font-size: 14px;
  }
@media screen and (max-width:450px){
  .newsInfo{
    overflow: hidden;
  }
  .mainCon{
    width:90%;
    margin-left: 5%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newsInfo.vue